module.exports = __webpack_public_path__ + "img/step-10.c1bffe0b.jpg";